module.exports = __webpack_public_path__ + "img/icon-select-arrow-white.6915a312.svg";